export class IEmailTemplate {
  _id?: string;
  organization: string;
  label: string;
  html: string;
  json: string;
  createdAt?: Date;
  updatedAt?: Date;
}

export interface ICreateEmailTemplateDTO extends Partial<IEmailTemplate> {}

export interface IUpdateEmailTemplateDTO extends Partial<IEmailTemplate> {}

export enum DefaultTemplates {
  UserVerifyAccount,
  UserForgotPassword,
  AdminNewPassword,
  AdminSignUpInvite,
  InboxMessage,
  ActivateAccount
}